import React from 'react';
import useDreamSummary from '../hooks/useDreamSummary';
import { streakLine } from '../utils/dreamBoost';
import '../styles/DreamBoost.css';

// The purchase-streak line the embed shows on Home and Profile (dreamStreak.js):
// "3 more days to +5 entries". Nothing renders without a streak worth naming.
function DreamStreak() {
  const summary = useDreamSummary();
  const copy = streakLine(summary);
  if (!copy) return null;
  return <div className="dream-streak">{copy}</div>;
}

export default DreamStreak;
